export const apiGeneric = {
  error:
    "Sorry we seem to be experiencing an issue. Please retry or contact your IT support staff if the issue persists."
};
